import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import { portalId, oauth } from '../../constants/leadinConfig';
import UISpacer from '../UIComponents/UISpacer';
import AuthWrapper from '../Auth/AuthWrapper';
import PreviewForm from './PreviewForm';
import FormSelect from './FormSelect';
import { monitorFormPreviewRender } from '../../api/hubspotPluginApi';
export default function FormEdit({ attributes, isSelected, setAttributes, preview = true, origin = 'gutenberg', }) {
    const { formId, formName } = attributes;
    const formSelected = portalId && formId;
    const handleChange = (selectedForm) => {
        setAttributes({
            portalId,
            formId: selectedForm.value,
            formName: selectedForm.label,
        });
    };
    useEffect(() => {
        monitorFormPreviewRender(origin);
    }, [origin]);
    return (_jsxs(Fragment, { children: [(isSelected || !formSelected) &&
                (!oauth ? (_jsx(AuthWrapper, { children: _jsx(FormSelect, { formId: formId, formName: formName, handleChange: handleChange, origin: origin }) })) : (_jsx(FormSelect, { formId: formId, formName: formName, handleChange: handleChange, origin: origin }))), formSelected && (_jsxs(Fragment, { children: [isSelected && _jsx(UISpacer, {}), preview && _jsx(PreviewForm, { portalId: portalId, formId: formId })] }))] }));
}
